import {Component, OnInit, TemplateRef} from '@angular/core';
import {CommonComponent} from '../../shared/common/common.component';
import {AccountService} from '../../../services/account.service';
import {NotificationsService} from '../../../services/notifications.service';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {IGeneric} from '../../../domain/IGeneric';
import {ECatalog} from '../../../enums/ECatalog';
import {CatalogsService} from '../../../services/catalogs.service';
import {ToastaService} from 'ngx-toasta';
import {NgForm} from '@angular/forms';
import {Router} from '@angular/router';
import {LangChangeEvent, TranslateService} from '@ngx-translate/core';
import {DialogService} from 'primeng/dynamicdialog';
import {CountryCode} from '../../../entity/CountryCodeEntity';
import {ConfigurationService} from '../../../services/configuration.service';
import {ReCaptchaV3Service} from 'ng-recaptcha';

@Component({
  selector: 'app-phone-number-change',
  templateUrl: './phone-number-change.component.html',
  styleUrls: ['./phone-number-change.component.scss']
})
export class PhoneNumberChangeComponent extends CommonComponent implements OnInit {
  phoneNumber: string = null;
  password: string;
  showPassword: boolean;
  phoneCountryCode: string;
  countries: IGeneric[] = null;
  waitingOtp: boolean;
  otpLength = 6;
  countryCodes: CountryCode[] = [];

  constructor(
    private accountsService: AccountService,
    private catalogsService: CatalogsService,
    protected modalService: NgbModal,
    protected notificationsService: NotificationsService,
    protected toastService: ToastaService,
    protected router: Router,
    public translate: TranslateService,
    protected dialogService: DialogService,
    public configurationService: ConfigurationService,
    private recaptchaV3Service: ReCaptchaV3Service
  ) {
    super(modalService, notificationsService, toastService, router, translate, dialogService);
    translate.onLangChange.subscribe(
      (event: LangChangeEvent) => {
        this.countryCodes = this.countryCodeCatalog(this.configurationService.application);
      });
  }

  ngOnInit(): void {
    this.countryCodes = this.countryCodeCatalog(this.configurationService.application);
    this.phoneCountryCode = !this.phoneCountryCode ? '1' : this.phoneCountryCode;
    this.getCountriesCatalog();
  }
  generateRecaptcha(){
    this.recaptchaV3Service.execute('send_otp').subscribe((token) => {
      this.submit(token);
    }, error => {
      this.msgError(error, this.translate.instant('shared.common.general_error_message'));
    }
    );
  }

  submit(token: string) {
    this.loadingModalOn();
    this.accountsService.phoneNumberChange(this.password, this.phoneCountryCode, this.phoneNumber, token).subscribe(
      (response: any) => {
        this.waitingOtp = true;
        this.loadingModalOff();
      }, error => {
        this.msgError(error);
        this.loadingModalOff();
      }
    );
  }

  validateCellPhone(otp, form: NgForm) {
    if (this.waitingOtp && otp.length === this.otpLength) {
      this.loadingModalOn();
      this.accountsService.otpVerification(otp, this.phoneCountryCode, this.phoneNumber).subscribe(
        (response: any) => {
          this.msgSuccess(this.translate.instant('accounts.phone_change.message_success'));
          this.waitingOtp = false;
          form.resetForm();
          this.loadingModalOff();
        },
        error => {
          this.loadingModalOff();
          switch (error.status) {
            case 422:
              this.msgError(error, this.translate.instant('accounts.phone_change.invalid_code'));
              break;
            default:
              this.msgError(this.translate.instant('accounts.phone_change.error'));
          }
        }
      );
    }
  }

  getCountriesCatalog() {
    this.catalogsService.getCatalog(ECatalog.COUNTRY).subscribe(
      (response: any) => {
        this.countries = [];
        for (const country of response) {
          if (country.phoneCountryCode) {
            this.countries.push({id: country.id, phoneCountryCode: country.phoneCountryCode, value: country.value});
          }
        }
      }, error => {
        this.msgError(error);
      }
    );
  }

  openModal(content: TemplateRef<any>): void {
    this.modalService.open(content, {
      size: 'md',
      centered: true,
      backdrop: 'static',
      keyboard: false
    });
  }
}
